import React from 'react';
import { Typography } from '@mui/material';

const Title = (props) => (
  <Typography
    fontWeight='700' variant='h6' mb={1} {...props}
  />
);

export default Title;
